import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import RevisionVotes from 'presentations/components/revision_votes';

const mapStateToProps = (state, { params }) => {
  const { revisionId } = params;
  const { currentRevisions } = state.project.presentations;

  return {
    revision: (currentRevisions || []).find(r => r.id === parseInt(revisionId))
  };
}

export default withRouter(connect(mapStateToProps)(RevisionVotes));



// WEBPACK FOOTER //
// ./presentations/containers/revision_votes.js